export const PdfBlock = {
    block(block){
        return {
            name : 'Upload pdf',
            fields: block.fields ?? [],
            files: block.files ?? [],
            type: 'upload-pdf',
            uuid: block.uuid ?? 0,
            lock: block.lock ?? 0,
            connected_parent_conditional_id: block.connected_parent_conditional_id ?? [],
            role_id: block.role_id ?? 0,
            attachment_name: block.attachment_name ?? 'Upload PDF',
            request_from: block.request_from ?? 0,
            uploading_is : block.uploading_is ?? 0,
            allow_multiple: block.allow_multiple ?? false,
            reusable: block.reusable ?? 0,
            is_parent: block.is_parent ?? 0,
            page: block.page ?? 0,
        }
    }
}